import { render, staticRenderFns, recyclableRender, components } from "./uni-swipe-action-item.vue?vue&type=template&id=bb66970c&scoped=true&filter-modules=eyJzd2lwZSI6eyJ0eXBlIjoic2NyaXB0IiwiY29udGVudCI6IiIsInN0YXJ0Ijo1ODc4LCJhdHRycyI6eyJzcmMiOiIuL2luZGV4Lnd4cyIsIm1vZHVsZSI6InN3aXBlIiwibGFuZyI6Ind4cyJ9LCJlbmQiOjU4Nzh9fQ%3D%3D&"
var renderjs
import script from "./uni-swipe-action-item.vue?vue&type=script&lang=js&"
export * from "./uni-swipe-action-item.vue?vue&type=script&lang=js&"
import style0 from "./uni-swipe-action-item.vue?vue&type=style&index=0&id=bb66970c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_@dcloudio_vue-cli-plugin-uni@2.0.0-28320200727001@@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb66970c",
  null,
  false,
  components,
  renderjs
)

/* custom blocks */
import block0 from "./index.wxs?vue&type=custom&index=0&blockType=script&issuerPath=D%3A%5Cproject%5CuniFrame%5Cuni-frame%5Csrc%5Ccomponents%5Cuni-swipe-action-item%5Cuni-swipe-action-item.vue&module=swipe&lang=wxs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "components/uni-swipe-action-item/uni-swipe-action-item.vue"
export default component.exports